<rt-dialog-header
  [heading]="'app.requisitions.create_dialog.heading' | translate"
  [subheading]="'app.requisitions.create_dialog.subheading' | translate"
>
</rt-dialog-header>
<rt-dialog-body layout-vertical>
  <rt-new-item-button
    [heading]="'app.requisitions.create_dialog.button_blank_heading' | translate"
    [subheading]="'app.requisitions.create_dialog.button_blank_subheading' | translate"
    [icon]="'border-color'"
    (click)="createBlank()"
  ></rt-new-item-button>
  <rt-new-item-button
    [heading]="'app.requisitions.create_dialog.button_duplicate_heading' | translate"
    [subheading]="'app.requisitions.create_dialog.button_duplicate_subheading' | translate"
    [icon]="'content-copy'"
    (click)="createDuplicate()"
    margin-top
  ></rt-new-item-button>
</rt-dialog-body>
